import { styled } from 'goober';

export const TableHeader = styled('h5')`
  ${({ theme }) => theme.typography.companyInfo.tableHeader};
`;
